import React from "react";
import PropTypes from "prop-types";
import DetailsDesktop from "./DetailsDesktop";

function Details({ app, config }) {
  return <DetailsDesktop app={app} config={config} />;
}

Details.defaultProps = {
  app: null,
  config: {},
};

Details.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Details;
